module.exports = __webpack_public_path__ + "static/media/KuehneNagelSingapore.51d5b23a.png";